import React, { FC, useEffect, useState } from "react";
import CopyToClipboard from "../CopyToClipboard/CopyToClipboard";

type UrlToClipboardProps = {
  color?: string;
};

const UrlToClipboard: FC<UrlToClipboardProps> = ({ color }) => {
  const style: any = { height: "30px", width: "30px" };
  if (color) style.color = color;

  return <CopyToClipboard onCopy={() => window.location.href} style={style} />;
};

export default UrlToClipboard;
